// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__PL0qO","HeaderCard":"Card_HeaderCard__uQs5Q","Title":"Card_Title__mGQyo"};